import { render, staticRenderFns } from "./BetgameEditPoints.vue?vue&type=template&id=02118966&scoped=true"
import script from "./BetgameEditPoints.vue?vue&type=script&lang=js"
export * from "./BetgameEditPoints.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditPoints.vue?vue&type=style&index=0&id=02118966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02118966",
  null
  
)

export default component.exports